import React, { useCallback, useContext } from 'react'
import { DiscountBanner as DiscountBannerWC } from '@grammarly/website-components'

import { getConfig } from '../../../config'
import { navHelper } from '../../../lib/services/navigation'
import { useUserService } from '../../../lib/hooks'
import { composeUrl } from '../../../lib/utils/url'
import { EventProps, gnarClient } from '../../../lib/tracking/gnar'
import { PageContext } from '../../../contexts/page-context'

const config = getConfig()

interface DiscountBannerProps {
  discountValue: number
}

export const DiscountBanner: React.FC<DiscountBannerProps> = ({ discountValue }) => {
  const { pageId, slug } = useContext(PageContext)
  const { isAnonymous } = useUserService().currentUser

  const gnarTrackFn = useCallback(
    (trackEventProps: EventProps) => {
      return gnarClient.track({ ...trackEventProps, pageId, pageSlug: slug })
    },
    [pageId, slug]
  )

  const llamaDownloadFirstUrl = composeUrl(config.paths.funnel.llamaDownloadFirst, navHelper.currentQueryParams)
  const signUpUrl = composeUrl(config.paths.funnel.signup, navHelper.currentQueryParams)
  const upgradeUrl = composeUrl(config.paths.funnel.upgrade, navHelper.currentQueryParams)
  const targetUrl = isAnonymous ? signUpUrl : upgradeUrl

  const handleClick = () => {
    if (isAnonymous) {
      window.open(llamaDownloadFirstUrl, '_blank')
    }

    navHelper.navigateFunnelPath(targetUrl)
  }

  return (
    <DiscountBannerWC
      clientName="cms"
      gnarTrackFn={gnarTrackFn}
      discountPercent={discountValue}
      targetUrl={targetUrl}
      onClick={handleClick}
    />
  )
}
